//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: 'Cpts020',
        props: {

        },
        data () {
            return {
                show: true
            }
        },
        mounted () {
            const that = this
            setTimeout(function () {
                that.show = false
            }, 500)
        }
    }
